import { render, staticRenderFns } from "./LocationComponent.vue?vue&type=template&id=7b970e1c&"
import script from "./LocationComponent.vue?vue&type=script&lang=js&"
export * from "./LocationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports